<template>
  <div>
    <a-modal
      title="请选择要截图下载的公告"
      :width="1280"
      :visible="visible"
      :footer="null"
      :destroyOnClose="true"
      @cancel="handleClose"
    >
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        rowKey="id"
        :pagination="false"
      >
        <span
          slot="operation"
          slot-scope="text, row"
          class="operation-link-cell"
        >
          <a @click="previewNotice(row)">查看</a>
          <a-divider type="vertical" />
          <a @click="downloadNotice(row)">下载</a>
        </span>
      </a-table>
      <div class="modal-footer-center">
        <a-button @click="handleClose">关闭</a-button>
      </div>
    </a-modal>

    <a-modal
      :title="preview.title"
      :width="760"
      :visible="preview.visible"
      :footer="null"
      :destroyOnClose="true"
      @cancel="closePreview"
    >
      <div class="notice-preview">
        <img
          v-if="preview.imageUrl"
          :src="preview.imageUrl"
          class="preview-img"
          alt="公告截图"
        />
        <div v-else class="preview-image">
          <div class="preview-title">{{ preview.title }}</div>
          <div class="preview-subtitle">公告截图预览</div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  downloadNoticeScreenshot,
  listNoticeScreenshot,
  previewNoticeScreenshot,
} from "@/api/project/Project.js";

export default {
  name: "NoticeScreenshotModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      data: [],
      columns: [
        { title: "项目名称", dataIndex: "projectName" },
        { title: "公告标题", dataIndex: "noticeTitle", width: 220 },
        { title: "操作时间", dataIndex: "operateTime", width: 240 },
        {
          title: "操作",
          width: 160,
          scopedSlots: { customRender: "operation" },
        },
      ],
      preview: {
        visible: false,
        title: "",
        imageUrl: "",
      },
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.data = [];
        this.getList();
      }
    },
  },
  methods: {
    getList() {
      const webId = (this.record || {}).webId;
      if (!webId) return;

      this.loading = true;
      listNoticeScreenshot({ webId })
        .then((res) => {
          this.data = Array.isArray(res.data) ? res.data : [];
        })
        .catch((err) => {
          this.data = [];
          this.$notification["error"]({
            message: "公告截图查询失败",
            description: this.getErrorMessage(err),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    previewNotice(row) {
      previewNoticeScreenshot({ id: row.id })
        .then((res) => {
          const data = res.data || row;
          if (!data.fileUrl) {
            this.$message.warning("当前公告截图暂无可预览地址");
            return;
          }
          this.preview.title = data.noticeTitle || row.noticeTitle;
          this.preview.imageUrl = data.fileUrl;
          this.preview.visible = true;
        })
        .catch((err) => {
          this.$notification["error"]({
            message: "公告截图预览失败",
            description: this.getErrorMessage(err),
          });
        });
    },

    closePreview() {
      this.preview.visible = false;
      this.preview.imageUrl = "";
    },

    downloadNotice(row) {
      if (!row || !row.id) return;
      downloadNoticeScreenshot({ id: row.id })
        .then((blob) => {
          this.saveBlob(blob, row.fileName || "公告截图.png");
        })
        .catch((err) => {
          this.$notification["error"]({
            message: "公告截图下载失败",
            description: this.getErrorMessage(err),
          });
        });
    },

    handleClose() {
      this.$emit("close");
    },

    saveBlob(blob, fileName) {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },

    getErrorMessage(err) {
      return (
        ((err.response || {}).data || {}).msg ||
        ((err.response || {}).data || {}).message ||
        err.msg ||
        err.message ||
        "网络异常，请稍后再试"
      );
    },
  },
};
</script>

<style scoped>
.operation-link-cell a {
  color: #1890ff;
  font-weight: 500;
}

.operation-link-cell /deep/ .ant-divider {
  background: #d9d9d9;
}

.modal-footer-center {
  margin-top: 28px;
  text-align: center;
}

.modal-footer-center .ant-btn {
  min-width: 120px;
}

.notice-preview {
  display: flex;
  justify-content: center;
  padding: 12px 0 24px;
}

.preview-image {
  width: 560px;
  height: 320px;
  border: 1px solid #e8e8e8;
  background: linear-gradient(180deg, #f4f8ff 0%, #fff 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #555;
}

.preview-img {
  max-width: 100%;
  max-height: 70vh;
  object-fit: contain;
}

.preview-title {
  font-size: 24px;
  margin-bottom: 12px;
}

.preview-subtitle {
  color: #999;
}
</style>
